<template>
<div class="w-statistics">
  <ul>
    <li v-for="(item,index) in data" :key="index">
      <div class="icon">
        <img :src="item.src" />
      </div>
      <div class="desc">
        <div class="tip">{{item.desc}}</div>
        <div class="number">{{item.number}}</div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return [{
            src: '/static/images/svolt/mei-icon.png',
            number: '17,250.50',
            desc: '节约标准煤（吨）'
          },
          {
            src: '/static/images/svolt/yang-icon.png',
            number: '17,250.50',
            desc: '二氧化碳减排量（吨）'
          },
          {
            src: '/static/images/svolt/shu-icon.png',
            number: '17,250.50',
            desc: '相当于植树（颗）'
          }
        ]
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="scss">
.w-statistics {
  height: 50px;
  line-height: 50px;
  display: inline-block;

  ul {
    width: 100%;
    height: 100%;
    display: inline-block;

    // li:nth-child(1) {
    //     width: 170px;
    // }

    // li:nth-child(2) {
    //     width: 160px;
    // }

    // li:nth-child(3) {
    //     width: 160px;
    // }

    // li:nth-child(4) {
    //     width: 190px;
    // }

    // li:nth-child(5) {
    //     width: 160px;
    // }

    li {
      width: 300px;
      height: 50px;
      list-style: none;
      display: inline-block;

      .icon {
        position: absolute;

        img {
          width: 165px;
          height: 30px;
        }
      }

      .desc {
        width: auto;
        position: absolute;
        margin-left: 30px;

        .tip {
          font-size: 14px;
          font-family: pmzd;
          color: #2C2F35;
          float: left;
          height: 50px;
          line-height: 50px;
        }

        .number {
          color: #19191A;
          font-size: 24px;
          font-family: Helvetica;
          font-weight: 500;
          float: left;
          height: 50px;
          line-height: 50px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/w-statistics.vue